/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Payment from '@/model/dataLayer/api/common/Payment'
import { getAllMemberCardList, getNfcCardList } from '@/model/dataLayer/api/bills/CouponSalesRecord'
import dayjs from 'dayjs'
import { getOrderDetail } from '@/model/dataLayer/api/bills/HistoryBills'

const entity = {
  orderIdDisplay: {
    displayName: 'orderId'
  },
  amount: {},
  memberCardId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          const nfcList = await getNfcCardList()
          const memberCardList = (await getAllMemberCardList())
          return [...nfcList, ...memberCardList]
        },
        itemText: 'longId'
      }
    }
  },
  paymentMethodId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Payment.getList,
        itemText: '_langsname'
      }
    },
    displayName: 'PaymentType'
  }
}
const config = {
  load: async function (filter) {
    const [fromDateTime, toDateTime] = filter[0].dateFilter
    const res = (await hillo.get('MemberCard.php', {
      op: 'showConsumeLogByDate',
      fromDateTime: fromDateTime + ' 04:00:00',
      toDateTime: dayjs(toDateTime).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59'
    })).content
    for (const item of res) {
      item.returningOrderId = (await getOrderDetail(item.orderId)).returningOrderId ?? ''
      if (item.returningOrderId) {
        item.amount = (-item.amount).toFixed(2)
        item.orderIdDisplay = item.orderId + ' (Return#' + item.returningOrderId + ')'
      } else {
        item.orderIdDisplay = item.orderId
      }
    }
    return res
  }
}

export async function getUsedMemberCardListByDate (dateRange) {
  const [fromDateTime, toDateTime] = dateRange
  const nfcList = await getNfcCardList()
  const memberCardList = (await getAllMemberCardList())
  const allList = [...nfcList, ...memberCardList]
  return (await hillo.get('MemberCard.php', {
    op: 'showConsumeLogByDate',
    fromDateTime: fromDateTime + ' 04:00:00',
    toDateTime: dayjs(toDateTime).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59'
  })).content.map(it => {
    it.memmberCardName = allList.find(item => item.id === it.memberCardId)?.longId ?? ''
    return it
  })
}

export default IKDataEntity.ModelFactory(entity, config)
